import { Box, Typography } from '@mui/material';
import '../../../App.css';
import colorData from '../../../json/color.json';

type props = {
  text: string;
}

/**
 * 経営理念のタイトルコンポーネント
 * @param text string
 * @returns 
 */
const VisionTitle: React.FC<props> = ({ text }) => {
  
  const textStyle ={
    color:colorData['black'],
    fontSize:40,
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    lineHeight: 2,
    fontWeight: 'bold'
  }
 

  return (
    <Box style={{paddingTop:30}}>
      <Typography variant="h2" sx={textStyle}>
       {text}
      </Typography>
    </Box>
  );

}

export default VisionTitle;
